export default "__VITE_ASSET__Cquj$1bi__"